
import {
  SherpaDialog,
  SherpaDialogContent,
  SherpaDialogFooter,
  SherpaDialogHeader,
  SherpaDialogTitle,
} from "@/components/ui-kit/dialog"
import { Button as UiKitButton } from "@/components/ui-kit/button"
import { Contract } from "@/types/contract"
import type { Invoice } from "@/types/invoice"
import { UnpaidInvoicesLine } from "@/components/invoices/unpaid-invoices-line"
import { CreditCardIcon } from "@/components/icons"
import { payableInvoices } from "@/lib/invoice-utils"

export function ContractsInvoicesDialog({
  open,
  onOpenChange,
  contract,
  onPay,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  contract: Contract
  onPay: (invoices: Invoice[]) => void
}) {
  const unpaidInvoices = payableInvoices(contract.invoices ?? [])

  return (
    <SherpaDialog open={open} onOpenChange={onOpenChange}>
      <SherpaDialogContent className="max-sm:left-0 max-sm:h-auto max-sm:max-h-[90dvh] max-sm:w-full max-sm:max-w-none max-sm:translate-x-0 max-sm:[--sherpa-dialog-height:auto]">
        <SherpaDialogHeader className="gap-6 mb-2">
          <SherpaDialogTitle>Неоплаченные счета бокса {contract.unitItem?.code ?? contract.unit}</SherpaDialogTitle>
        </SherpaDialogHeader>

        <div className="flex flex-col gap-4 divide-y divide-border">
          {unpaidInvoices?.map(invoice => (
            <UnpaidInvoicesLine
              key={invoice.id}
              invoice={invoice}
              onPay={() => onPay([invoice])}
            />
          ))}
        </div>

        <SherpaDialogFooter className="flex-col gap-4 sm:flex-col sm:justify-start pt-[10px]">
          <UiKitButton
            type="button"
            className="h-[60px] w-full"
            onClick={() => onPay(unpaidInvoices ?? [])}
            endIcon={<CreditCardIcon size={24} />}
          >
            Оплатить все
          </UiKitButton>
        </SherpaDialogFooter>
      </SherpaDialogContent>
    </SherpaDialog>
  )
}
